import { useState } from 'react';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $profileFeatureStore, $userAccountsStore } from '@lib/store';
import { AccountUtils, cn, FormatUtils } from '@shared/utils';
import type { UserResponse } from '@shared/api';
import { Button, Icon, Modal, Text } from '@shared/widgets';
import CrossIcon from '@assets/icons/cross.svg';

interface IRemoveAccountsProps {
  show: boolean;
  onClose: () => void;
  userData: UserResponse;
}

export const RemoveAccountsModal = (props: IRemoveAccountsProps) => {
  const profileFeatureStore = useUnit($profileFeatureStore.store);
  const userAccountsStore = useUnit($userAccountsStore.store);

  const [selectedAccounts, setSelectedAccounts] = useState<number[]>([]);

  const { t } = useTranslation('user');

  const closeHandler = () => {
    setSelectedAccounts([]);
    props.onClose();
  };
  const confirmRemoveHandler = async () => {
    if (!selectedAccounts.length) {
      closeHandler();
      return;
    }
    $userAccountsStore.events.deleteAccount({ userIds: props.userData.id, accountIds: selectedAccounts });
    closeHandler();
  };

  return (
    <Modal isOpen={props.show} onClose={closeHandler} title={t('modals.removeAccounts.title')}>
      <div className='flex flex-col gap-2'>
        {profileFeatureStore.data?.accountFlows &&
          AccountUtils.filterAccounts(profileFeatureStore.data.accountFlows, userAccountsStore.data).map((account, idx) => (
            <div
              key={idx}
              className={cn(
                'flex w-full items-center justify-between rounded-sm bg-white p-2 pl-3 dark:bg-slate',
                selectedAccounts.includes(account.id) && 'pointer-events-none opacity-50',
              )}
            >
              <div className='shrink pr-4'>
                <Text className='text-ellipsis' size='sm'>
                  {FormatUtils.toSliceNumber(account.accountNumber)}
                </Text>
                <Text className='text-ellipsis' size='xs' color='gray'>
                  {account.name}
                </Text>
              </div>
              <Button className='p-0' color='icon' onClick={() => setSelectedAccounts((prev) => [...prev, account.id])}>
                <Icon icon={<CrossIcon className='h-6 w-6' />} color='red' />
              </Button>
            </div>
          ))}
      </div>
      <Button className='mt-5' color='primary' fullWidth disabled={userAccountsStore.loading} onClick={confirmRemoveHandler}>
        {t('buttons.confirm', { ns: 'common' })}
      </Button>
    </Modal>
  );
};
